import countryAgnosticValidateSsn from './validateSsn';
var ssnRegexGenerator = function (strict) {
    if (strict === void 0) { strict = true; }
    // https://fr.wikipedia.org/wiki/Num%C3%A9ro_de_s%C3%A9curit%C3%A9_sociale_en_France#Signification_des_chiffres_du_NIR
    // If necessary copy paste the code in the JS console, copy the regex and inspect & debug it on https://regex101.com/
    var REGEX_000_TO_999 = '[0-9]{3}';
    var REGEX_001_TO_999 = "(?!000)".concat(REGEX_000_TO_999);
    var REGEX_00_TO_99 = '[0-9]{2}';
    var REGEX_01_TO_99 = "(?!00)".concat(REGEX_00_TO_99);
    var REGEX_01_TO_97 = "(?!98|99)".concat(REGEX_01_TO_99);
    var REGEX_01_TO_12 = '0[1-9]|1[0-2]';
    var REGEX_20_TO_42 = '[2-3][0-9]|4[0-2]';
    var REGEX_50_TO_99 = '[5-9][0-9]';
    /* eslint-disable max-len */
    var foreignersRegex = '[3478]' + // position: 1 | gender
        REGEX_00_TO_99 + // position: 2-3 | last 2 digits of birth year
        "(00|".concat(REGEX_01_TO_12, "|").concat(REGEX_20_TO_42, "|").concat(REGEX_50_TO_99, ")") + // position: 4-5 | last two digits of birth month or 20-42 or 50-99
        "(2[AB]|".concat(REGEX_00_TO_99, ")") + // position: 6-7 | birth department 01 to 99, or 2A or 2B for corsica
        REGEX_000_TO_999 + // position: 8-10 | for foreigners, country code from 000 to 999
        REGEX_000_TO_999; // position: 11-12 birth count in the month, by god knows what, 000 to 999
    var frenchRegex = '[12]' + // position: 1 | gender
        REGEX_00_TO_99 + // position: 2-3 | last 2 digits of birth year
        "(".concat(REGEX_01_TO_12, "|").concat(REGEX_20_TO_42, "|").concat(REGEX_50_TO_99, ")") + // position: 4-5 | last two digits of birth month or 20-42 or 50-99
        "(2[AB]|".concat(REGEX_01_TO_99, ")") + // position: 6-7 | birth department 01 to 99, or 2A or 2B for corsica
        REGEX_001_TO_999 + // position: 8-10 | commune code 001 to 999 (avoid 000 !)
        REGEX_001_TO_999; // position: 11-12 birth count in the month, by commune or country 001 to 999
    /* eslint-enable max-len */
    var format = "(".concat(frenchRegex, "|").concat(foreignersRegex, ")").concat(REGEX_01_TO_97);
    return strict ? new RegExp("^".concat(format, "$")) : new RegExp(format);
};
export var ssnRegex = ssnRegexGenerator();
export var ssnRegexExtract = ssnRegexGenerator(false);
export var validateSsn = function (ssn) {
    return countryAgnosticValidateSsn({
        ssnRegex: ssnRegexGenerator(),
        computeSsnControlKey: computeSsnControlKey,
        extractSsnControlKey: extractSsnControlKey,
    }, ssn);
};
export function computeSsnControlKey(ssnWithOrWithoutKey) {
    var ssnWithoutKey = ssnWithOrWithoutKey.slice(0, 13).replace('2A', '19').replace('2B', '18');
    if (ssnWithOrWithoutKey.length !== 13 && ssnWithOrWithoutKey.length !== 15) {
        throw new Error('ssn provided has wrong size');
    }
    var ssnNumber = Number(ssnWithoutKey);
    if (Number.isNaN(ssnNumber)) {
        throw new Error('ssn provided is invalid');
    }
    var ssnControlKey = 97 - (ssnNumber % 97);
    return ssnControlKey < 10 ? "0".concat(ssnControlKey) : String(ssnControlKey);
}
export function extractSsnControlKey(ssnWithKey) {
    if (ssnWithKey.length !== 15) {
        throw new Error('ssn is not 15 chars long');
    }
    var controlKey = ssnWithKey.slice(13, 15);
    if (Number.isNaN(Number(controlKey))) {
        throw new Error('ssn provided has an invalid control key');
    }
    return controlKey;
}
